import { apiFetch, setAccessToken } from './client';
import type { RegisterRequest, LoginRequest, AuthResponse, ApiSuccess } from '@spi/shared';

export async function register(data: RegisterRequest): Promise<ApiSuccess> {
  return apiFetch('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function login(data: LoginRequest): Promise<AuthResponse> {
  const result = await apiFetch<AuthResponse>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify(data),
  });
  setAccessToken(result.accessToken);
  return result;
}

export async function logout(): Promise<void> {
  await apiFetch('/api/auth/logout', { method: 'POST' });
  setAccessToken(null);
}

export async function refreshSession(): Promise<AuthResponse | null> {
  try {
    const res = await fetch('/api/auth/refresh', {
      method: 'POST',
      credentials: 'include',
    });
    if (!res.ok) return null;
    const { accessToken } = await res.json();
    setAccessToken(accessToken);

    // Fetch user profile
    const profileRes = await fetch('/api/users/me', {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!profileRes.ok) return null;
    const user = await profileRes.json();
    return { accessToken, user };
  } catch {
    return null;
  }
}

export async function forgotPassword(email: string): Promise<ApiSuccess> {
  return apiFetch('/api/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

export async function resetPassword(token: string, password: string): Promise<ApiSuccess> {
  return apiFetch('/api/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify({ token, password }),
  });
}

export async function verifyEmail(token: string): Promise<ApiSuccess> {
  return apiFetch(`/api/auth/verify-email?token=${encodeURIComponent(token)}`);
}
